import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import numberWithCommas from "../../../../utils/numbersWithComma";

import BackIcon from "../../../../assets/svg/BackIcon";

import DepositIcon from "../../../../assets/images/icons/Deposit.webp";
import WithdrawIcon from "../../../../assets/images/icons/withdraw.webp";
import AccountStatementIcon from "../../../../assets/images/icons/AccountStatement.webp";
import MybetsIcon from "../../../../assets/images/icons/MyBet.webp";

import DepositImg from "../../../../assets/images/banner/deposit.gif";
import WithdrawImg from "../../../../assets/images/banner/withdraw.gif";
import AccountStatementImg from "../../../../assets/images/banner/accountstatement.gif";
import MybetsImg from "../../../../assets/images/banner/mybets.gif";

import WalletIcon from "../../../../assets/images/icons/wallet-.png";

const Wallet = () => {
  const navigate = useNavigate();
  const { wallet } = useSelector((state) => state.auth);

  return (
    <div>
      <main>
        <div className="ActivitySection">
          <div className="GameHeader">
            <div className="backBtn" onClick={() => navigate(-1)}>
              <BackIcon />
            </div>
            <h4>Wallet</h4>
            <div></div>
          </div>
          <div className="WalletHeading">
            <img src={WalletIcon} />
            <div className="balance-amount mb-1">
              ₹{numberWithCommas(wallet?.cash || 0)}
            </div>
            <h1>Main Balance</h1>
          </div>
          <div className="ActivityBox Walletbox mb-4">
            <ul>
              <li>
                <a href="/gatewaylist">
                  <img src={DepositIcon} alt="DepositIcon" />
                  <span>Deposit</span>
                </a>
              </li>
              <li>
                <a href="/withdraw">
                  <img src={WithdrawIcon} alt="WithdrawIcon" />
                  <span>Withdraw</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img src={MybetsIcon} alt="MybetsIcon" />
                  <span>Deposit History</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img src={AccountStatementIcon} alt="AccountStatementIcon" />
                  <span>Account Statement</span>
                </a>
              </li>
            </ul>
          </div>
          {/* <div className="ActivityImg">
            <ul>
              <li>
                <img src={DepositImg} />
              </li>
              <li>
                <img src={MybetsImg} />
              </li>
              <li>
                <img src={WithdrawImg} />
              </li>
              <li>
                <img src={AccountStatementImg} />
              </li>
            </ul>
          </div> */}
        </div>
      </main>
    </div>
  );
};

export default Wallet;
